import { apiSlice } from "../apiSlice";

const TESTING_ENVIRONMENT_BASE_URL =
    process.env.REACT_APP_SLDL_TESTING_ENVIRONMENT_API_BASE_URL;

export const paymntService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: `payhere/create-payment`,
        method: "POST",
        body: data,
      }),
    }),

    userStateUpdate: builder.mutation({
      query: (data) => ({
        url: `payhere/pro/success`,
        method: "POST",
        body: data,
      }),
    }),

    getPaymentStatus: builder.query({
      query: (orderId) => ({
        url: `payhere/status/${orderId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useCreateOrderMutation, useUserStateUpdateMutation, useLazyGetPaymentStatusQuery } =
    paymntService;
